import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const buttonStyles = css`
  box-sizing: border-box;
  word-break: keep-all;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
`;

// 모든 버튼에 공통적으로 필요한 스타일을 정의함
export const Button = styled.button`
  ${buttonStyles}
`;
